<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="80px">
        <!-- 函授站： -->
        <!-- <div class="tx_box">
          <div>函授站：</div>
          <input type="text"   />
        </div> -->
        <!-- 学历层次 -->
        <!-- <div class="tx_box">
          <div>学历层次：</div>
          <input type="text"   />
        </div> -->
        <!-- 年级 -->
        <!-- <div class="tx_box">
          <div>年级：</div>
          <input disabled v-model="userInfo.grade" type="text" />
        </div> -->
        <!-- 专业 -->
        <div class="tx_box">
          <div>专业：</div>
          <input disabled v-model="userInfo.majorName" type="text" />
        </div>
        <!-- 班级 -->
        <div class="tx_box">
          <div>班级：</div>
          <input disabled v-model="userInfo.clbumName" type="text" />
        </div>
        <!-- 学号 -->
        <div class="tx_box">
          <div>学号：</div>
          <input disabled v-model="userInfo.stuNum" type="text" />
        </div>
        <!-- 学制 -->
        <div class="tx_box">
          <div>学制：</div>
          <input disabled v-model="userInfo.educational" type="text" />
        </div>
        <!-- 学习类型 -->
        <!-- <div class="tx_box">
          <div>学习类型：</div>
          <input type="text" />
        </div> -->
        <!-- <div @click="onSubmit" class="btn">保存</div> -->
      </el-form>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "../../../assets/js/api.js";
export default {
  data() {
    return {
      userInfo: "",
      minzuSelected: "汉族",
      picked: "女",
      form: {
        realName: "",
        gender: 0,
        email: "",
        sign: "",
      },
      options: ["汉族", "a", "b"],
      address: {
        province: "",
        city: "",
        county: "",
      },
      activeTabs: 1,
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserInfo(localStorage.getItem("siteId"),localStorage.getItem("info")).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.userInfo = res.data;
          console.log(res.data)
        }
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    onSelected(data) {
      this.address.province = data.province.value;
      this.address.city = data.city.value;
      this.address.county = data.area.value;
    },
    // 监听民族选项
    getMinzu(e) {
      // console.log(e);
      // console.log(this.minzuSelected);
    },
  },
};
</script>
<style lang="less" scoped>
.form_box {
  width: 700px;
  margin-top: 40px;
  font-size: 14px;
  color: #333;
  margin-left: 30px;
  .tx_box {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    font-size: 16px;
    color: #343434;
    // margin-top: 40px;
    div:nth-child(1) {
      width: 90px;
      text-align: right;
      margin-right: 20px;
    }
    input {
      width: 340px;
      height: 40px;
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 4px;
      padding-left: 10px;
      box-sizing: border-box;
    }
    .input2 {
      width: 157px;
    }
    .radio_box {
      margin-right: 40px;
      display: flex;
      align-items: center;
      .radio {
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
    }
    .minxu {
      width: 157px;
      height: 40px;
      border: 1px solid #cccccc;
      border-radius: 4px;
      padding-left: 10px;
      box-sizing: border-box;
    }
    @deep: ~">>>";
    .el-date-editor.el-input,
    .el-input--prefix .el-input__inner {
      width: 230px;
      height: 30px;
      //   padding-left: 10px;
    }
    @deep: ~">>>";
    .el-input__inner {
      padding-left: 10px;
      border: 1px solid #ccc;
    }
    // @deep: ~">>>";
    // .el-radio__label {
    //   font-size: 16px;
    //   color: #343434;
    // }
  }
  .btn {
    width: 144px;
    height: 40px;
    background: #029aff;
    border-radius: 4px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    margin-left: 110px;
  }
}
</style>
